import Fresh from './pages/Fresh'
import 'bootstrap/dist/css/bootstrap.css';

function App() {
  return (
    <div> <Fresh /> </div>
  );
}

export default App;
